import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';

import { map } from 'rxjs/operators';
import { VConfigService } from '../../vconfig/vconfig.service';
import { PartnerService } from '../partner.service';

const HIDE_PRICING = 'hide_pricing';

@Injectable({ providedIn: 'root' })
export class HidePricingGuard {
  constructor(
    private vconfig: VConfigService,
    private partner: PartnerService,
  ) {}

  hidePricing: boolean = null;

  canActivate(): Observable<boolean> {
    if (this.hidePricing !== null) {
      return observableOf(this.hidePricing);
    }
    return this.checkHidePricing();
  }

  checkHidePricing(): Observable<boolean> {
    // Even super admins must respect the “Hide wholesale prices in Partner Center” option. Otherwise when we
    // are doing demoes, the wholesale costs shows up in pages like Discover Products and Activation page when
    // we switch into PIDs, which frequently has caused awkward conversations with customers.
    return this.vconfig.getConfigurations(this.partner.partnerId, [HIDE_PRICING]).pipe(
      map((result) => {
        this.hidePricing = !!result[HIDE_PRICING];
        return this.hidePricing;
      }),
    );
  }
}
